module.exports = __webpack_public_path__ + "static/img/deal_7.a9cd4d45.png";